/**
 * Code kind
 */
export var CodeKind;
(function (CodeKind) {
    CodeKind[CodeKind["CLASS"] = 0] = "CLASS";
    CodeKind[CodeKind["FUNCTION"] = 1] = "FUNCTION";
    CodeKind[CodeKind["INTERFACE"] = 2] = "INTERFACE";
    CodeKind[CodeKind["OBJECT"] = 3] = "OBJECT";
    //ENUM,
    CodeKind[CodeKind["PROXY_CLASS"] = 100] = "PROXY_CLASS";
    CodeKind[CodeKind["PROXY_FUNCTION"] = 101] = "PROXY_FUNCTION";
    CodeKind[CodeKind["PROXY_INTERFACE"] = 102] = "PROXY_INTERFACE";
})(CodeKind || (CodeKind = {}));
/**
 * Method kind
 */
export var MethodKind;
(function (MethodKind) {
    MethodKind[MethodKind["PUBLIC"] = 0] = "PUBLIC";
    MethodKind[MethodKind["PROTECTED"] = 1] = "PROTECTED";
})(MethodKind || (MethodKind = {}));
